import { FC, ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { RoutesEnum } from '../../utils/routesEnum'
import { Container } from './styles'

type LoggedUserProps = {
  name: string;
  avatar?: string;
}

const LoggedUser: FC<LoggedUserProps> = ({ name, avatar }): ReactElement => {
  return (
    <Container>
      <div className='content'>
        Olá{' '}
        <span className='name'>{name}</span>
        <br />
        <Link className='logout' to={RoutesEnum.LOGOUT}>Sair</Link>
      </div>
      <div className='avatar'>
        <img src={avatar || 'https://joeschmoe.io/api/v1/random'} alt='avatar' />
      </div>
    </Container>
  )
}

export default LoggedUser
